import initJSLinks from '@resources/js/js-links';


const initHouseSitter = ({ partnerUrl, beforeActionCallback }) => {
    const containers = document.querySelectorAll('.js-pet-sitter')
    const markup = `
        <span>You can also consider a pet sitter for your pet. </span>
        <span class="link" style="font-weight:bold;text-decoration:underline;cursor:pointer;" data-hsl="${btoa(partnerUrl)}" data-target="_blank">Click here to find a trusted sitter in your city.</span>
    `

    if (!containers.length) return

    containers.forEach((container) => {
        container.insertAdjacentHTML('beforeend', markup)
    })

    initJSLinks('hsl')
}

export default initHouseSitter
